import { render, staticRenderFns } from "./fileUploadNormal.vue?vue&type=template&id=0fcf7349&scoped=true"
import script from "./fileUploadNormal.vue?vue&type=script&lang=js"
export * from "./fileUploadNormal.vue?vue&type=script&lang=js"
import style0 from "./fileUploadNormal.vue?vue&type=style&index=0&id=0fcf7349&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcf7349",
  null
  
)

export default component.exports